"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Bookmarks1: ['bookmarks-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.516,17.488h4.5a.5.5,0,0,1,.5.5v4.5a1.407,1.407,0,0,0,.825,1.421A1.264,1.264,0,0,0,7.818,24a1.549,1.549,0,0,0,1.107-.516L23.417,8.992a2,2,0,0,0,0-2.825L17.834.585A1.982,1.982,0,0,0,16.421,0h0a1.978,1.978,0,0,0-1.412.585L.516,15.076a1.408,1.408,0,0,0-.422,1.587A1.41,1.41,0,0,0,1.516,17.488Z']],
  Bookmarks2: ['bookmarks-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,6.5a1,1,0,0,0,1-1V4a4,4,0,0,0-4-4H7A4,4,0,0,0,3,4V22.484a1.407,1.407,0,0,0,.825,1.421,1.407,1.407,0,0,0,1.589-.421l3.232-3.231a.5.5,0,0,1,.708,0l3.232,3.231A1.549,1.549,0,0,0,13.693,24a1.274,1.274,0,0,0,.482-.095A1.407,1.407,0,0,0,15,22.484V4.11a2.079,2.079,0,0,1,1.662-2.084A2,2,0,0,1,19,4V5.5A1,1,0,0,0,20,6.5Z']],
  TagsAdd: ['tags-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.422,19.5a1.972,1.972,0,0,0,1.406.582H6.84a1.975,1.975,0,0,0,1.41-.6l1.217-1.241a.493.493,0,0,0,.136-.367,7.976,7.976,0,0,1,8.2-8.363.486.486,0,0,0,.363-.143l.939-.958A3.984,3.984,0,0,0,20.086,6V2a2,2,0,0,0-2-2h0L13.826,0a3.758,3.758,0,0,0-2.413,1L.586,11.834a2,2,0,0,0,0,2.828Zm7.164-14a2,2,0,1,1,2,2A2,2,0,0,1,12.586,5.5Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm9-.75a.75.75,0,0,1,0,1.5H18.5a.25.25,0,0,0-.25.25V20a.75.75,0,0,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H15a.75.75,0,1,1,0-1.5h1.5a.25.25,0,0,0,.25-.25V15a.75.75,0,0,1,1.5,0v1.5a.25.25,0,0,0,.25.25Z']],
  Bookmarks: ['bookmarks', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.25,22.234a1,1,0,0,0,.293.707l.543.543A1.549,1.549,0,0,0,18.193,24a1.274,1.274,0,0,0,.482-.095,1.407,1.407,0,0,0,.825-1.421V2a2,2,0,0,0-2-2h-.75a.5.5,0,0,0-.5.5Z', 'M10.1,20.3l1.542-1.541a.5.5,0,0,1,.708,0L13.9,20.3a.5.5,0,0,0,.854-.353V.5a.5.5,0,0,0-.5-.5H9.75a.5.5,0,0,0-.5.5V19.943A.5.5,0,0,0,10.1,20.3Z', 'M7.25,0H6.5a2,2,0,0,0-2,2V22.484a1.407,1.407,0,0,0,.825,1.421,1.409,1.409,0,0,0,1.589-.421l.543-.543a1,1,0,0,0,.293-.707V.5A.5.5,0,0,0,7.25,0Z']],
  BookmarksDocument: ['bookmarks-document', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2.5A1.75,1.75,0,0,0,22.25.749H12a1,1,0,0,0-1,1v8.5a.5.5,0,0,1-.9.3L8.2,8.015a.25.25,0,0,0-.4,0L5.9,10.547a.5.5,0,0,1-.9-.3v-8.5a1,1,0,0,0-1-1H1.75A1.75,1.75,0,0,0,0,2.5v19a1.751,1.751,0,0,0,1.75,1.75h20.5A1.751,1.751,0,0,0,24,21.5ZM4.25,17.749A.75.75,0,0,1,5,17H16.5a.75.75,0,0,1,0,1.5H5A.75.75,0,0,1,4.25,17.749ZM19.5,6.5h-5a.75.75,0,0,1,0-1.5h5a.75.75,0,0,1,0,1.5Zm.75,3.25a.75.75,0,0,1-.75.75h-5a.75.75,0,0,1,0-1.5h5A.75.75,0,0,1,20.25,9.749ZM19.5,13a.75.75,0,0,1,0,1.5H5A.75.75,0,0,1,5,13Z']],
  Tags1: ['tags-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.476,13.588h0L10.894,1A3.931,3.931,0,0,0,8.483,0H2A2,2,0,0,0,0,2L.007,8.486a3.739,3.739,0,0,0,1,2.411L13.586,23.476A1.674,1.674,0,0,0,14.764,24a1.481,1.481,0,0,0,.355-.044,1.6,1.6,0,0,0,1.127-1.144L17.7,18.036a.5.5,0,0,1,.332-.332l4.774-1.457a1.54,1.54,0,0,0,.666-2.659ZM5.993,7.492a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,5.993,7.492Z']],
  TagsAlert: ['tags-alert', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.6,9.882l1.427-1.456a3.974,3.974,0,0,0,.983-2.407V2.035A1.994,1.994,0,0,0,18.023.043h0L13.775.048a3.93,3.93,0,0,0-2.4,1L.583,11.835a2,2,0,0,0,0,2.819L5.4,19.473a1.968,1.968,0,0,0,1.4.579h.012a1.967,1.967,0,0,0,1.405-.594l5.528-5.642,1.176-2.24a2.92,2.92,0,0,1,2.365-1.553A.493.493,0,0,0,17.6,9.882Zm-1.078-4.36a1.993,1.993,0,1,1-1.993-1.993A1.993,1.993,0,0,1,16.526,5.522Z', 'M18.8,12.271a1.444,1.444,0,0,0-2.553,0l-5.038,9.6a1.422,1.422,0,0,0,.048,1.4,1.447,1.447,0,0,0,1.228.684H22.562a1.448,1.448,0,0,0,1.228-.684,1.422,1.422,0,0,0,.048-1.4ZM17.524,14.74a.747.747,0,0,1,.747.748v2.989a.747.747,0,1,1-1.494,0V15.488A.747.747,0,0,1,17.524,14.74Zm0,5.481a1,1,0,1,1-1,1A1,1,0,0,1,17.524,20.221Z']],
  TagsAlternate: ['tags-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.291,16.12a3,3,0,0,0,0-4.242l-11-11A2.978,2.978,0,0,0,9.169,0H2A2,2,0,0,0,0,2V9.17a2.978,2.978,0,0,0,.879,2.122l11,11a3,3,0,0,0,4.242,0Zm-1.414-1.414-6.172,6.172a1.025,1.025,0,0,1-1.414,0l-11-11A1,1,0,0,1,2,9.17V2.5A.5.5,0,0,1,2.5,2H9.169a1,1,0,0,1,.708.293l11,11a1,1,0,0,1,0,1.414Z', 'M4.498 5.999 A1.500 1.500 0 1 0 7.498 5.999 A1.500 1.500 0 1 0 4.498 5.999 Z']],
  TagsBlockAlternate: ['tags-block-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.671 5.999 A1.500 1.500 0 1 0 18.671 5.999 A1.500 1.500 0 1 0 15.671 5.999 Z', 'M9.9,21.191a.249.249,0,0,0-.32-.114,1.027,1.027,0,0,1-1.117-.2L2.292,14.706a1,1,0,0,1,0-1.414l11-11A.993.993,0,0,1,14,2h6.672a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708l-.166.166a.25.25,0,0,0,.058.4A8.038,8.038,0,0,1,22,11.257a.249.249,0,0,0,.341-.027,2.928,2.928,0,0,0,.826-2.06V2a2,2,0,0,0-2-2H14a2.978,2.978,0,0,0-2.121.879l-11,11a3,3,0,0,0,0,4.242L7.05,22.292a3.005,3.005,0,0,0,3.57.5.25.25,0,0,0,.076-.373A8.079,8.079,0,0,1,9.9,21.191Z', 'M17.25,10.749a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.25,10.749Zm0,11a4.419,4.419,0,0,1-2.1-.532.249.249,0,0,1-.059-.4l5.727-5.727a.249.249,0,0,1,.214-.07.246.246,0,0,1,.183.129,4.422,4.422,0,0,1,.532,2.1A4.5,4.5,0,0,1,17.25,21.749Zm2.1-8.468a.255.255,0,0,1,.129.184.25.25,0,0,1-.071.214L13.68,19.406a.251.251,0,0,1-.4-.059,4.435,4.435,0,0,1-.532-2.1,4.505,4.505,0,0,1,4.5-4.5A4.439,4.439,0,0,1,19.349,13.281Z']],
  TagsDoubleAlternate: ['tags-double-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.291,16.95a3,3,0,0,0,0-4.243l-8-8a2.982,2.982,0,0,0-2.122-.878H2a2,2,0,0,0-2,2V13a2.982,2.982,0,0,0,.879,2.122l8,8a3,3,0,0,0,4.242,0Zm-1.414-1.414-6.172,6.171a1.025,1.025,0,0,1-1.414,0l-8-8A.991.991,0,0,1,2,13V6.329a.5.5,0,0,1,.5-.5H9.169a1,1,0,0,1,.708.293l8,8a1,1,0,0,1,0,1.414Z', 'M4.498 9.829 A1.500 1.500 0 1 0 7.498 9.829 A1.500 1.500 0 1 0 4.498 9.829 Z', 'M3.828,2.249a.249.249,0,0,0,.25.25H5.62a.25.25,0,0,0,.236-.167A.5.5,0,0,1,6.328,2H13a.993.993,0,0,1,.707.293l8,8a1,1,0,0,1,0,1.414l-.712.712a.252.252,0,0,0,0,.354l1.061,1.06a.249.249,0,0,0,.353,0l.713-.712a3,3,0,0,0,0-4.242l-8-8A2.982,2.982,0,0,0,13,0H5.828a2,2,0,0,0-2,2Z']],
  TagsCheckAlternate: ['tags-check-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.670 5.999 A1.500 1.500 0 1 0 18.670 5.999 A1.500 1.500 0 1 0 15.670 5.999 Z', 'M9.9,21.191a.249.249,0,0,0-.32-.114,1.029,1.029,0,0,1-1.118-.2L2.291,14.706a1,1,0,0,1,0-1.414l11-11A1,1,0,0,1,14,2H20.67a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708l-.166.166a.251.251,0,0,0,.059.4A7.98,7.98,0,0,1,22,11.257a.25.25,0,0,0,.342-.027,2.927,2.927,0,0,0,.825-2.06V2a2,2,0,0,0-2-2H14a2.982,2.982,0,0,0-2.122.879l-11,11a3,3,0,0,0,0,4.242l6.172,6.172a3.005,3.005,0,0,0,3.57.5.251.251,0,0,0,.077-.373A8,8,0,0,1,9.9,21.191Z', 'M17.457,11a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.457,11Zm-.727,9.675c-.037,0-.074,0-.111,0a1.487,1.487,0,0,1-1.055-.444l-1.5-1.5a.75.75,0,0,1,1.06-1.06l1.3,1.3a.247.247,0,0,0,.2.072.25.25,0,0,0,.182-.1L19.531,15.3a.75.75,0,1,1,1.2.9l-2.9,3.874A1.493,1.493,0,0,1,16.73,20.674Z']],
  TagsCheck: ['tags-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.2,9.373l.941-.96A3.985,3.985,0,0,0,20.127,6V2a2,2,0,0,0-2-2h0L13.869.005a3.95,3.95,0,0,0-2.416,1L.628,11.833a2,2,0,0,0,0,2.829L5.463,19.5a1.977,1.977,0,0,0,1.406.581h.012a1.975,1.975,0,0,0,1.41-.6L9.343,18.41a.484.484,0,0,0,.135-.376,7.99,7.99,0,0,1,8.349-8.518A.493.493,0,0,0,18.2,9.373ZM12.627,5.5a2,2,0,1,1,2,2A2,2,0,0,1,12.627,5.5Z', 'M17.458,11a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.458,11Zm-.727,9.675c-.037,0-.075,0-.112,0a1.487,1.487,0,0,1-1.055-.444l-1.5-1.5a.75.75,0,1,1,1.061-1.06l1.3,1.3a.251.251,0,0,0,.377-.027L19.531,15.3a.75.75,0,0,1,1.2.9l-2.9,3.874A1.5,1.5,0,0,1,16.731,20.674Z']],
  TagsFavoriteAlternate: ['tags-favorite-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.670 5.999 A1.500 1.500 0 1 0 18.670 5.999 A1.500 1.500 0 1 0 15.670 5.999 Z', 'M13.96,12.545a3.525,3.525,0,0,0-1.936,5.965l5.114,5.335a.5.5,0,0,0,.722,0l5.106-5.327a3.525,3.525,0,1,0-4.985-4.986l-.305.3a.25.25,0,0,1-.354,0l-.3-.3A3.5,3.5,0,0,0,13.96,12.545Z', 'M11.248,19.868a.247.247,0,0,0-.178-.077.251.251,0,0,0-.179.073L9.877,20.878a1.025,1.025,0,0,1-1.414,0L2.291,14.706a1,1,0,0,1,0-1.414l11-11A1,1,0,0,1,14,2H20.67a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708l-.7.7a.25.25,0,0,0,.182.427h.1a5.071,5.071,0,0,1,1.752.309.071.071,0,0,0,.076-.016A2.978,2.978,0,0,0,23.17,9.17V2a2,2,0,0,0-2-2H14a2.98,2.98,0,0,0-2.122.879l-11,11a3,3,0,0,0,0,4.242l6.172,6.172a3,3,0,0,0,4.242,0l.992-.991a.251.251,0,0,0,0-.35Z']],
  TagsEdit: ['tags-edit', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.016,6.02V2.034A2,2,0,0,0,18.025.042h0l-4.241,0a3.74,3.74,0,0,0-2.407,1L.583,11.836a2,2,0,0,0,0,2.818L5.4,19.474a1.967,1.967,0,0,0,1.4.58h.011a1.968,1.968,0,0,0,1.406-.595L19.033,8.426A3.775,3.775,0,0,0,20.016,6.02Zm-3.488-.5a1.993,1.993,0,1,1-1.993-1.994A1.993,1.993,0,0,1,16.528,5.522Z', 'M12.779,20.018a.5.5,0,0,0-.831.215l-.883,3.09a.5.5,0,0,0,.479.635.458.458,0,0,0,.137-.019l3.09-.883a.5.5,0,0,0,.215-.831Z', 'M18.791,13.224a.5.5,0,0,0-.705,0l-4.993,4.993a.5.5,0,0,0,0,.705l2.989,2.99a.5.5,0,0,0,.7,0l4.994-4.994a.5.5,0,0,0,0-.7Z', 'M19.5,11.811a.5.5,0,0,0,0,.708l2.99,2.99a.538.538,0,0,0,.376.123.576.576,0,0,0,.376-.169,2.617,2.617,0,0,0,0-3.694A2.649,2.649,0,0,0,19.5,11.811Z']],
  TagsFavoriteStar: ['tags-favorite-star', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.387,17.754A2.718,2.718,0,0,1,11.665,13.5h1.351a.5.5,0,0,0,.459-.3c.289-.671.949-2.2.907-2.1a2.835,2.835,0,0,1,2.525-1.6,2.545,2.545,0,0,1,.673.1.5.5,0,0,0,.49-.132L19.1,8.412A3.789,3.789,0,0,0,20.085,6V2a2,2,0,0,0-2-2h0L13.827.005a3.747,3.747,0,0,0-2.414,1L.585,11.833a2,2,0,0,0,0,2.829L5.421,19.5a1.972,1.972,0,0,0,1.406.582h.012a1.973,1.973,0,0,0,1.41-.6l1.08-1.1A.5.5,0,0,0,9.387,17.754ZM16.585,5.5a2,2,0,1,1-2-2A2,2,0,0,1,16.585,5.5Z', 'M22.146,15h-2.5a.249.249,0,0,1-.23-.151L18.072,11.73l-.013-.027a1.293,1.293,0,0,0-2.317.027L14.4,14.847a.251.251,0,0,1-.23.15h-2.5a1.228,1.228,0,0,0-1.166.76,1.269,1.269,0,0,0,.319,1.4l2.194,1.955a.249.249,0,0,1,.063.286l-1.223,2.814a1.255,1.255,0,0,0,.315,1.452,1.28,1.28,0,0,0,1.505.166l3.112-1.753a.251.251,0,0,1,.246,0l3.112,1.753a1.3,1.3,0,0,0,.642.172,1.29,1.29,0,0,0,.864-.338,1.257,1.257,0,0,0,.316-1.451L20.74,19.4a.249.249,0,0,1,.063-.286l2.212-1.972a1.264,1.264,0,0,0,.3-1.378A1.233,1.233,0,0,0,22.146,15Z']],
  TagsFavorite: ['tags-favorite', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.105,8.413A3.985,3.985,0,0,0,20.091,6V2a2,2,0,0,0-2-2h0L13.833.005a3.945,3.945,0,0,0-2.415,1L.592,11.833a2,2,0,0,0,0,2.829L5.428,19.5a1.976,1.976,0,0,0,1.406.581h.011a1.976,1.976,0,0,0,1.411-.6L9.268,18.45a.5.5,0,0,0,.1-.539,5.02,5.02,0,0,1,6.448-6.578.494.494,0,0,0,.535-.108ZM12.591,5.5a2,2,0,1,1,2,2A2,2,0,0,1,12.591,5.5Z', 'M13.46,12.545a3.524,3.524,0,0,0-1.935,5.965l5.113,5.335a.5.5,0,0,0,.722,0l5.107-5.328a3.525,3.525,0,0,0-4.986-4.985l-.305.3a.25.25,0,0,1-.353,0l-.3-.3A3.5,3.5,0,0,0,13.46,12.545Z']],
  TagsMinus: ['tags-minus', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.161,9.369l.938-.957A3.988,3.988,0,0,0,20.085,6V2a2,2,0,0,0-2-2h0L13.825,0a3.755,3.755,0,0,0-2.412,1L.585,11.833a2,2,0,0,0,0,2.829L5.421,19.5a1.977,1.977,0,0,0,1.406.581h.012a1.973,1.973,0,0,0,1.41-.6l1.216-1.241a.482.482,0,0,0,.136-.366,7.977,7.977,0,0,1,8.2-8.364A.486.486,0,0,0,18.161,9.369ZM12.585,5.5a2,2,0,1,1,2,2A2,2,0,0,1,12.585,5.5Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.5,7.25H15a.75.75,0,1,1,0-1.5h5a.75.75,0,0,1,0,1.5Z']],
  TagsRefresh: ['tags-refresh', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17,9.249a7.5,7.5,0,0,1,.878.055.5.5,0,0,0,.414-.147l.73-.745A3.79,3.79,0,0,0,20.007,6V2a2,2,0,0,0-2-2h0L13.75.005a3.751,3.751,0,0,0-2.415,1L.507,11.834a2,2,0,0,0,0,2.828L5.344,19.5a1.977,1.977,0,0,0,1.406.581h.011a1.976,1.976,0,0,0,1.411-.6l.515-.525a.5.5,0,0,0,.138-.417A7.779,7.779,0,0,1,8.75,17.5,8.259,8.259,0,0,1,17,9.249ZM12.507,5.5a2,2,0,1,1,2,2A2,2,0,0,1,12.507,5.5Z', 'M11.354,22.782l.969-.97a.25.25,0,0,1,.359.006,6.086,6.086,0,0,0,10.21-2.2A1,1,0,0,0,21,18.972a4.091,4.091,0,0,1-6.918,1.419.249.249,0,0,1,.008-.344l1.721-1.722a.5.5,0,0,0-.353-.853H11a.5.5,0,0,0-.5.5v4.457a.492.492,0,0,0,.068.224.464.464,0,0,0,.087.111.47.47,0,0,0,.154.126A.5.5,0,0,0,11.354,22.782Z', 'M21.621,12.655a.249.249,0,0,1-.358,0,6.1,6.1,0,0,0-10.2,2.227,1,1,0,0,0,1.893.648,4.091,4.091,0,0,1,6.9-1.445.248.248,0,0,1-.006.346l-1.659,1.66a.5.5,0,0,0,.353.853H23a.5.5,0,0,0,.5-.5V11.983a.5.5,0,0,0-.309-.462.488.488,0,0,0-.455.061c-.029.019-.065.023-.09.048Z']],
  TagsSettings: ['tags-settings', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.473 17.030 A1.500 1.500 0 1 0 18.473 17.030 A1.500 1.500 0 1 0 15.473 17.030 Z', 'M8.493,17.046A8.486,8.486,0,0,1,18.52,8.687a.5.5,0,0,0,.448-.141l.131-.134A3.79,3.79,0,0,0,20.084,6V2a2,2,0,0,0-2-2h0L13.827.005a3.747,3.747,0,0,0-2.414,1L.585,11.833a2,2,0,0,0,0,2.829L5.421,19.5a1.977,1.977,0,0,0,1.406.581h.011a1.976,1.976,0,0,0,1.411-.6l.288-.294a.5.5,0,0,0,.133-.451A8.351,8.351,0,0,1,8.493,17.046ZM14.585,7.5a2,2,0,1,1,2-2A2,2,0,0,1,14.585,7.5Z', 'M22.977,13.541a1.75,1.75,0,0,0-1.936-.842l-1.412.327a.449.449,0,0,1-.532-.31l-.424-1.392a1.776,1.776,0,0,0-3.4,0l-.423,1.392a.456.456,0,0,1-.534.31L12.905,12.7a1.783,1.783,0,0,0-1.7,2.953l.987,1.066a.461.461,0,0,1,0,.625l-.987,1.065a1.783,1.783,0,0,0,1.7,2.953l1.412-.327a.454.454,0,0,1,.533.311l.423,1.391a1.776,1.776,0,0,0,3.4,0l.423-1.391a.448.448,0,0,1,.534-.311l1.411.327a1.783,1.783,0,0,0,1.7-2.953l-.988-1.065a.463.463,0,0,1,0-.625l.988-1.066A1.757,1.757,0,0,0,22.977,13.541Zm-6,6.489a3,3,0,1,1,3-3A3,3,0,0,1,16.973,20.03Z']],
  TagsSearch: ['tags-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.1,8.412A3.979,3.979,0,0,0,20.086,6V2a2,2,0,0,0-2-2h0L13.828.005a3.95,3.95,0,0,0-2.416,1L.586,11.834a2,2,0,0,0,0,2.828L5.422,19.5a1.977,1.977,0,0,0,1.406.581H6.84a1.975,1.975,0,0,0,1.41-.6l.892-.91a.491.491,0,0,0,.124-.46,6.726,6.726,0,0,1,.5-4.546,7.116,7.116,0,0,1,2.663-2.953,6.665,6.665,0,0,1,5.12-.958.5.5,0,0,0,.461-.134ZM12.586,5.5a2,2,0,1,1,2,2A2,2,0,0,1,12.586,5.5Z', 'M10.578,16.528a5.523,5.523,0,0,0,8.5,4.66.25.25,0,0,1,.311.034l2.484,2.484a1,1,0,1,0,1.414-1.414L20.8,19.808a.25.25,0,0,1-.033-.312,5.528,5.528,0,1,0-10.19-2.968Zm9.059,0A3.53,3.53,0,1,1,16.107,13,3.534,3.534,0,0,1,19.637,16.528Z']],
  TagsUpload: ['tags-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.558,9.76a.5.5,0,0,0,.367-.15l1.174-1.2A3.791,3.791,0,0,0,20.085,6V2a2,2,0,0,0-2-2h0L13.827.005a3.747,3.747,0,0,0-2.414,1L.585,11.834a2,2,0,0,0,0,2.828L5.421,19.5a1.972,1.972,0,0,0,1.406.582h.012a1.975,1.975,0,0,0,1.41-.6l1.036-1.057a.5.5,0,0,0,.142-.369A7.976,7.976,0,0,1,17.558,9.76ZM12.585,5.5a2,2,0,1,1,2,2A2,2,0,0,1,12.585,5.5Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm-1,9.5v-2.75a.25.25,0,0,0-.25-.25H15.5a.5.5,0,0,1-.391-.813l2-2.5a.52.52,0,0,1,.782,0l2,2.5a.5.5,0,0,1-.391.813h-.75a.25.25,0,0,0-.25.25V20.5a1,1,0,0,1-2,0Z']],
  TagsShareAlternate: ['tags-share-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.671 5.999 A1.500 1.500 0 1 0 18.671 5.999 A1.500 1.500 0 1 0 15.671 5.999 Z', 'M23.873,13.749a2.746,2.746,0,1,0-5.437.539.25.25,0,0,1-.115.268l-2.666,1.6a.252.252,0,0,1-.288-.022,2.72,2.72,0,0,0-1.744-.634,2.75,2.75,0,1,0,2.055,4.559.252.252,0,0,1,.281-.067l2.272.909a.25.25,0,0,1,.157.246,2.756,2.756,0,1,0,.68-1.706.25.25,0,0,1-.28.067L16.523,18.6a.25.25,0,0,1-.156-.253,2.122,2.122,0,0,0-.056-.638.25.25,0,0,1,.115-.268l2.665-1.6a.25.25,0,0,1,.288.022,2.722,2.722,0,0,0,1.744.634A2.752,2.752,0,0,0,23.873,13.749Z', 'M10.281,20.87a.249.249,0,0,0-.182-.1.255.255,0,0,0-.192.073l-.029.03a1.025,1.025,0,0,1-1.414,0L2.292,14.706a1,1,0,0,1,0-1.414l11-11A.993.993,0,0,1,14,2h6.672a.5.5,0,0,1,.5.5V9.17a.987.987,0,0,1-.053.321V9.5l0,0a4.228,4.228,0,0,1,1.663.339.251.251,0,0,0,.219-.011.247.247,0,0,0,.126-.179,2.909,2.909,0,0,0,.039-.478V2a2,2,0,0,0-2-2H14a2.978,2.978,0,0,0-2.121.879l-11,11a3,3,0,0,0,0,4.242L7.05,22.292a3,3,0,0,0,4.242,0l.079-.08a.247.247,0,0,0,.072-.2.252.252,0,0,0-.113-.184A4.262,4.262,0,0,1,10.281,20.87Z']],
  Tags: ['tags', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.382,11.384,13.16,22.953l.017.016a2,2,0,0,0,2.808-.021l7.065-7.063a2,2,0,0,0-.012-2.841L11.3,1.5c-.018-.019-.035-.037-.054-.054A3.751,3.751,0,0,0,8.855.465H2.363a2,2,0,0,0-2,2L.37,8.96A3.784,3.784,0,0,0,1.382,11.384ZM4.863,6.465a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,4.863,6.465Z']],
  TagsDouble: ['tags-double', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,1.5a5.236,5.236,0,0,1,3.475,1.439l11,11,0,0a3.472,3.472,0,0,1,.862,1.442.249.249,0,0,0,.415.1l.66-.659a2,2,0,0,0,0-2.827h0l-11-11A3.749,3.749,0,0,0,10,0H5A1.994,1.994,0,0,0,3.2,1.142a.25.25,0,0,0,.226.357Z', 'M12,23.413A1.98,1.98,0,0,0,13.415,24h0a1.986,1.986,0,0,0,1.414-.585l3-3,2.586-2.586a2,2,0,0,0,0-2.827h0l-11-11A3.749,3.749,0,0,0,7,3H2A2,2,0,0,0,0,5v5a3.743,3.743,0,0,0,1,2.414ZM5.5,7A1.5,1.5,0,1,1,4,8.5,1.5,1.5,0,0,1,5.5,7Z']],
  TagsDouble1: ['tags-double-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,1.527a5.231,5.231,0,0,1,3.474,1.439l11,11a3.174,3.174,0,0,1,.6.861.25.25,0,0,0,.317.122l.519-.207a1.606,1.606,0,0,0,.557-2.714l-11-11a3.749,3.749,0,0,0-2.413-1h-5a1.99,1.99,0,0,0-1.8,1.143.247.247,0,0,0,.014.24.25.25,0,0,0,.212.117ZM22.763,12.734Z', 'M20.414,15.027l-11-11A3.934,3.934,0,0,0,7,3.027H2a2,2,0,0,0-2,2v5a3.936,3.936,0,0,0,1,2.414l11,11a1.712,1.712,0,0,0,1.207.529,1.545,1.545,0,0,0,.31-.031,1.658,1.658,0,0,0,1.2-1.057l1.39-3.474a.5.5,0,0,1,.278-.278l3.475-1.39a1.606,1.606,0,0,0,.557-2.714Zm-14.914-5A1.5,1.5,0,1,1,7,8.527,1.5,1.5,0,0,1,5.5,10.027Z']],
  BookmarksDocumentAlternate: ['bookmarks-document-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,3.428a1.96,1.96,0,0,0-1.96-1.96H11.485A1.468,1.468,0,0,0,10.04.244H6.122A1.47,1.47,0,0,0,4.677,1.468a1.518,1.518,0,0,0-.024.245v9.306a.489.489,0,0,0,.881.294L7.883,8.178a.246.246,0,0,1,.392,0l2.353,3.135a.5.5,0,0,0,.547.171.49.49,0,0,0,.335-.465V3.678a.25.25,0,0,1,.25-.25h9.78a.5.5,0,0,1,.5.5V21.54a.5.5,0,0,1-.5.5H2.459a.5.5,0,0,1-.5-.5V3.672A.244.244,0,0,1,2.2,3.428a.98.98,0,0,0,0-1.96H1.959A1.96,1.96,0,0,0,0,3.428V22.04A1.959,1.959,0,0,0,1.959,24H22.04A1.959,1.959,0,0,0,24,22.04Z', 'M14.449,7.591h3.918a.98.98,0,1,0,0-1.959H14.449a.98.98,0,1,0,0,1.959Z', 'M14.449,11.509h3.918a.98.98,0,1,0,0-1.959H14.449a.98.98,0,1,0,0,1.959Z', 'M18.37,13.468H6.122a.98.98,0,0,0,0,1.96H18.37a.98.98,0,0,0,0-1.96Z', 'M17.387,18.366a.979.979,0,0,0-.979-.979H6.122a.98.98,0,0,0,0,1.959H16.408A.979.979,0,0,0,17.387,18.366Z']],
  TagsAddAlternate: ['tags-add-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.670 5.999 A1.500 1.500 0 1 0 18.670 5.999 A1.500 1.500 0 1 0 15.670 5.999 Z', 'M9.9,21.191a.249.249,0,0,0-.32-.114,1.029,1.029,0,0,1-1.118-.2L2.291,14.706a1,1,0,0,1,0-1.414l11-11A1,1,0,0,1,14,2H20.67a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708l-.166.166a.249.249,0,0,0,.059.4A8.028,8.028,0,0,1,22,11.257a.25.25,0,0,0,.342-.027,2.927,2.927,0,0,0,.825-2.06V2a2,2,0,0,0-2-2H14a2.98,2.98,0,0,0-2.122.879l-11,11a3,3,0,0,0,0,4.242l6.172,6.172a3.005,3.005,0,0,0,3.57.5.25.25,0,0,0,.076-.373A8.073,8.073,0,0,1,9.9,21.191Z', 'M11,17.5A6.5,6.5,0,1,0,17.5,11,6.508,6.508,0,0,0,11,17.5Zm9-.75a.75.75,0,0,1,0,1.5H18.5a.25.25,0,0,0-.25.25V20a.75.75,0,0,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H15a.75.75,0,1,1,0-1.5h1.5a.25.25,0,0,0,.25-.25V15a.75.75,0,0,1,1.5,0v1.5a.25.25,0,0,0,.25.25Z']],
  TagsRemove: ['tags-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.24,9.375l.943-.963A3.982,3.982,0,0,0,20.169,6V2a2,2,0,0,0-2-2h0L13.909.005a3.938,3.938,0,0,0-2.412,1L.67,11.833a2,2,0,0,0,0,2.829L5.505,19.5a1.978,1.978,0,0,0,1.407.581h.012a1.971,1.971,0,0,0,1.409-.6l.972-.991a.492.492,0,0,0,.135-.38,8,8,0,0,1,8.422-8.595A.491.491,0,0,0,18.24,9.375ZM12.669,5.5a2,2,0,1,1,2,2A2,2,0,0,1,12.669,5.5Z', 'M17.416,11a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.416,11Zm2.651,8.091a.75.75,0,1,1-1.061,1.06l-1.414-1.414a.25.25,0,0,0-.353,0L15.825,20.15a.75.75,0,0,1-1.061-1.06l1.414-1.414a.25.25,0,0,0,0-.354l-1.414-1.414a.75.75,0,0,1,1.061-1.06l1.414,1.414a.25.25,0,0,0,.353,0l1.414-1.414a.75.75,0,0,1,1.061,1.06l-1.414,1.414a.25.25,0,0,0,0,.354Z']],
  TagsBlock: ['tags-block', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.254,17.031A7.322,7.322,0,0,1,11.318,12.3c2.687-2.882,4.995-3.278,7.078-2.966a.491.491,0,0,0,.429-.141l.525-.535a3.978,3.978,0,0,0,.985-2.413v-4a2,2,0,0,0-2-2h0L14.077.255a3.945,3.945,0,0,0-2.415,1L.835,12.084a2,2,0,0,0,0,2.828l4.837,4.837a1.977,1.977,0,0,0,1.405.581H7.09a1.971,1.971,0,0,0,1.409-.6l.73-.744a.49.49,0,0,0,.131-.428A7.967,7.967,0,0,1,9.254,17.031ZM12.835,5.748a2,2,0,1,1,2,2A2,2,0,0,1,12.835,5.748Z', 'M17.251,10.749a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.251,10.749Zm0,11a4.435,4.435,0,0,1-2.1-.532.251.251,0,0,1-.059-.4l5.728-5.727a.249.249,0,0,1,.4.059,4.434,4.434,0,0,1,.532,2.1A4.505,4.505,0,0,1,17.251,21.749Zm2.1-8.468a.251.251,0,0,1,.059.4L13.68,19.406a.251.251,0,0,1-.4-.059,4.426,4.426,0,0,1-.532-2.1,4.5,4.5,0,0,1,4.5-4.5A4.438,4.438,0,0,1,19.349,13.281Z']],
  TagsCashAlternate: ['tags-cash-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.670 5.999 A1.500 1.500 0 1 0 18.670 5.999 A1.500 1.500 0 1 0 15.670 5.999 Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11ZM16,21.249a.75.75,0,1,1,0-1.5h2.033a.592.592,0,0,0,.221-1.141l-2.065-.826a2.084,2.084,0,0,1,.361-3.98.25.25,0,0,0,.2-.245v-.308a.75.75,0,0,1,1.5,0v.25a.25.25,0,0,0,.25.25H19a.75.75,0,0,1,0,1.5H16.966a.592.592,0,0,0-.22,1.141l2.064.826a2.084,2.084,0,0,1-.36,3.98.249.249,0,0,0-.2.245v.308a.75.75,0,0,1-1.5,0V21.5a.25.25,0,0,0-.25-.25Z', 'M9.9,21.191a.249.249,0,0,0-.32-.114,1.029,1.029,0,0,1-1.118-.2L2.291,14.706a1,1,0,0,1,0-1.414l11-11A1,1,0,0,1,14,2H20.67a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708l-.166.166a.249.249,0,0,0,.059.4A8.028,8.028,0,0,1,22,11.257a.25.25,0,0,0,.342-.027,2.927,2.927,0,0,0,.825-2.06V2a2,2,0,0,0-2-2H14a2.98,2.98,0,0,0-2.122.879l-11,11a3,3,0,0,0,0,4.242l6.172,6.172a3.005,3.005,0,0,0,3.57.5.25.25,0,0,0,.076-.373A8.073,8.073,0,0,1,9.9,21.191Z']],
  TagsSettingsAlternate: ['tags-settings-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.671 5.999 A1.500 1.500 0 1 0 18.671 5.999 A1.500 1.500 0 1 0 15.671 5.999 Z', 'M9.9,21.191a.249.249,0,0,0-.32-.114,1.027,1.027,0,0,1-1.117-.2L2.292,14.706a1,1,0,0,1,0-1.414l11-11A.993.993,0,0,1,14,2h6.672a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708l-.166.166a.25.25,0,0,0,.058.4A8.038,8.038,0,0,1,22,11.257a.249.249,0,0,0,.341-.027,2.928,2.928,0,0,0,.826-2.06V2a2,2,0,0,0-2-2H14a2.978,2.978,0,0,0-2.121.879l-11,11a3,3,0,0,0,0,4.242L7.05,22.292a3.005,3.005,0,0,0,3.57.5.25.25,0,0,0,.076-.373A8.079,8.079,0,0,1,9.9,21.191Z', 'M15.473 17.030 A1.500 1.500 0 1 0 18.473 17.030 A1.500 1.500 0 1 0 15.473 17.030 Z', 'M22.977,13.541a1.752,1.752,0,0,0-1.936-.842l-1.412.327a.451.451,0,0,1-.533-.31l-.423-1.392a1.776,1.776,0,0,0-3.4,0l-.424,1.392a.454.454,0,0,1-.533.31L12.905,12.7a1.783,1.783,0,0,0-1.7,2.953l.988,1.066a.461.461,0,0,1,0,.625L11.2,18.408a1.783,1.783,0,0,0,1.7,2.953l1.412-.327a.453.453,0,0,1,.532.311l.424,1.391a1.776,1.776,0,0,0,3.4,0l.423-1.391a.449.449,0,0,1,.534-.311l1.411.327a1.783,1.783,0,0,0,1.7-2.953l-.987-1.065a.461.461,0,0,1,0-.625l.987-1.066A1.756,1.756,0,0,0,22.977,13.541Zm-6,6.489a3,3,0,1,1,3-3A3,3,0,0,1,16.973,20.03Z']],
  TagsFavoriteStarAlternate: ['tags-favorite-star-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.670 5.999 A1.500 1.500 0 1 0 18.670 5.999 A1.500 1.500 0 1 0 15.670 5.999 Z', 'M22.146,15h-2.5a.249.249,0,0,1-.229-.151L18.072,11.73l-.013-.027a1.294,1.294,0,0,0-2.318.027L14.4,14.847a.252.252,0,0,1-.23.151h-2.5a1.231,1.231,0,0,0-1.166.759,1.272,1.272,0,0,0,.32,1.4l2.194,1.955a.25.25,0,0,1,.063.286l-1.223,2.814a1.255,1.255,0,0,0,.314,1.452,1.278,1.278,0,0,0,1.506.166l3.112-1.753a.254.254,0,0,1,.245,0l3.113,1.753a1.3,1.3,0,0,0,.641.172,1.286,1.286,0,0,0,.865-.338,1.255,1.255,0,0,0,.315-1.451L20.739,19.4a.25.25,0,0,1,.063-.286l2.213-1.972a1.264,1.264,0,0,0,.3-1.378A1.234,1.234,0,0,0,22.146,15Z', 'M10.477,21.61l.836-1.924a.09.09,0,0,0-.146-.1l-1.29,1.291a1.027,1.027,0,0,1-1.415,0L2.291,14.706a1,1,0,0,1,0-1.414l11-11A.993.993,0,0,1,14,2H20.67a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708L19.62,11.134a.252.252,0,0,0-.053.276l.639,1.482a.252.252,0,0,0,.183.147.254.254,0,0,0,.224-.069l1.678-1.678A2.982,2.982,0,0,0,23.17,9.17V2a2,2,0,0,0-2-2H14a2.978,2.978,0,0,0-2.121.879l-11,11a3,3,0,0,0,0,4.242l6.171,6.172a3,3,0,0,0,3.024.738.249.249,0,0,0,.175-.244A2.755,2.755,0,0,1,10.477,21.61Z']],
  TagsMinusAlternate: ['tags-minus-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.671 5.999 A1.500 1.500 0 1 0 18.671 5.999 A1.500 1.500 0 1 0 15.671 5.999 Z', 'M9.9,21.191a.25.25,0,0,0-.32-.114,1.029,1.029,0,0,1-1.118-.2L2.292,14.706a1,1,0,0,1,0-1.414l11-11A1,1,0,0,1,14,2h6.671a.5.5,0,0,1,.5.5V9.171a.993.993,0,0,1-.293.707l-.166.166a.251.251,0,0,0,.059.4A8.023,8.023,0,0,1,22,11.257a.25.25,0,0,0,.342-.027,2.926,2.926,0,0,0,.825-2.059V2a2,2,0,0,0-2-2H14a2.982,2.982,0,0,0-2.122.879l-11,11a3,3,0,0,0,0,4.242L7.05,22.292a3,3,0,0,0,3.57.5.251.251,0,0,0,.077-.373A7.956,7.956,0,0,1,9.9,21.191Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.5,7.25H15a.75.75,0,1,1,0-1.5h5a.75.75,0,0,1,0,1.5Z']],
  TagsUploadAlternate: ['tags-upload-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.670 5.999 A1.500 1.500 0 1 0 18.670 5.999 A1.500 1.500 0 1 0 15.670 5.999 Z', 'M9.9,21.191a.249.249,0,0,0-.32-.114,1.029,1.029,0,0,1-1.118-.2L2.291,14.706a1,1,0,0,1,0-1.414l11-11A1,1,0,0,1,14,2H20.67a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708l-.166.166a.249.249,0,0,0,.059.4A8.028,8.028,0,0,1,22,11.257a.25.25,0,0,0,.342-.027,2.927,2.927,0,0,0,.825-2.06V2a2,2,0,0,0-2-2H14a2.98,2.98,0,0,0-2.122.879l-11,11a3,3,0,0,0,0,4.242l6.172,6.172a3.005,3.005,0,0,0,3.57.5.25.25,0,0,0,.076-.373A8.073,8.073,0,0,1,9.9,21.191Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm-1,9.5v-2.75a.25.25,0,0,0-.25-.25H15.5a.5.5,0,0,1-.391-.812l2-2.5a.518.518,0,0,1,.781,0l2,2.5a.5.5,0,0,1-.39.812h-.75a.25.25,0,0,0-.25.25V20.5a1,1,0,0,1-2,0Z']],
  Tags2: ['tags-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.974,10.451a7.033,7.033,0,0,0,0-6.409c-.01-.019-.018-.04-.028-.059-.076-.145-.164-.284-.25-.424-.038-.06-.07-.122-.109-.181-.06-.09-.13-.177-.2-.265A7.032,7.032,0,0,0,21.7,2.3c-.017-.017-.035-.031-.052-.047a6.977,6.977,0,0,0-.6-.525c-.075-.059-.153-.114-.23-.169q-.265-.19-.548-.354A7,7,0,0,0,11.8,2.3a6.925,6.925,0,0,0-1.518,2.28.987.987,0,0,0,.966,1.352l.034,0a.959.959,0,0,0,.845-.577A5,5,0,1,1,18.1,12.061a4.614,4.614,0,0,1-.716.137.253.253,0,0,1-.2-.066.249.249,0,0,1-.078-.2l.17-3.222a1.885,1.885,0,0,0-2-2l-4.719.248A4.18,4.18,0,0,0,8.2,8.017L.84,15.38a2,2,0,0,0,0,2.829l4.949,4.95a2,2,0,0,0,2.828,0h0l7.361-7.365a2.568,2.568,0,0,0,.186-.211.247.247,0,0,0,.033-.253.251.251,0,0,0-.207-.151,7.861,7.861,0,0,1-3.864-1.413.253.253,0,0,0-.115-.044,1.977,1.977,0,0,1-1.176-.563,2,2,0,0,1,2.828-2.828,1.94,1.94,0,0,1,.46.731.25.25,0,0,1-.293.326,1,1,0,0,0-1.065.45.988.988,0,0,0,.228,1.282,7.039,7.039,0,0,0,7.709-.1c.026-.018.051-.038.077-.057a6.739,6.739,0,0,0,.9-.747l.025-.022a6.95,6.95,0,0,0,.692-.818c.065-.088.135-.174.2-.265.039-.059.071-.121.108-.18.087-.14.175-.28.251-.425C22.957,10.488,22.965,10.469,22.974,10.451Zm-14.514,8a1,1,0,0,1-1.414,0l-1.5-1.5A1,1,0,0,1,6.96,15.538l1.5,1.5A1,1,0,0,1,8.46,18.452Z']],
  TagsDownload: ['tags-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.941,9.314a.5.5,0,0,0,.417-.146l.741-.756A3.789,3.789,0,0,0,20.085,6V2a2,2,0,0,0-2-2h0L13.827.005a3.751,3.751,0,0,0-2.415,1L.585,11.834a2,2,0,0,0,0,2.828L5.421,19.5a1.972,1.972,0,0,0,1.406.582h.012a1.975,1.975,0,0,0,1.41-.6l.7-.708a.5.5,0,0,0,.137-.42A7.985,7.985,0,0,1,17.941,9.314ZM12.585,5.5a2,2,0,1,1,2,2A2,2,0,0,1,12.585,5.5Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm-.391,9.812-2-2.5A.5.5,0,0,1,15.5,17.5h.75a.25.25,0,0,0,.25-.25V14.5a1,1,0,0,1,2,0v2.75a.25.25,0,0,0,.25.25h.75a.5.5,0,0,1,.391.812l-2,2.5a.5.5,0,0,1-.782,0Z']],
  TagsLockAlternate: ['tags-lock-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.670 5.999 A1.500 1.500 0 1 0 18.670 5.999 A1.500 1.500 0 1 0 15.670 5.999 Z', 'M22.714,15.514a.249.249,0,0,1-.214-.247V14.249a3.5,3.5,0,0,0-7,0v1.018a.25.25,0,0,1-.215.247A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17A1.5,1.5,0,0,0,22.714,15.514ZM20,20.249a1,1,0,1,1-1-1A1,1,0,0,1,20,20.249Zm-2.5-6a1.5,1.5,0,0,1,3,0v1a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25Z', 'M12.5,18.859a.25.25,0,0,0-.427-.177l-2.2,2.2a1.025,1.025,0,0,1-1.414,0L2.291,14.706a1,1,0,0,1,0-1.414l11-11A1,1,0,0,1,14,2H20.67a.5.5,0,0,1,.5.5V9.17a.984.984,0,0,1-.049.312.251.251,0,0,0,.125.3,5.013,5.013,0,0,1,1.192.84.251.251,0,0,0,.394-.066A2.986,2.986,0,0,0,23.17,9.17V2a2,2,0,0,0-2-2H14a2.982,2.982,0,0,0-2.122.879l-11,11a3,3,0,0,0,0,4.242l6.172,6.172a3,3,0,0,0,4.242,0l1.135-1.135a.252.252,0,0,0,.074-.177Z']],
  TagsRemoveAlternate: ['tags-remove-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.670 5.999 A1.500 1.500 0 1 0 18.670 5.999 A1.500 1.500 0 1 0 15.670 5.999 Z', 'M9.9,21.191a.249.249,0,0,0-.32-.114,1.029,1.029,0,0,1-1.118-.2L2.291,14.706a1,1,0,0,1,0-1.414l11-11A1,1,0,0,1,14,2H20.67a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708l-.166.166a.249.249,0,0,0,.059.4A8.028,8.028,0,0,1,22,11.257a.25.25,0,0,0,.342-.027,2.927,2.927,0,0,0,.825-2.06V2a2,2,0,0,0-2-2H14a2.98,2.98,0,0,0-2.122.879l-11,11a3,3,0,0,0,0,4.242l6.172,6.172a3.005,3.005,0,0,0,3.57.5.25.25,0,0,0,.076-.373A8.073,8.073,0,0,1,9.9,21.191Z', 'M17.415,11a6.5,6.5,0,1,0,6.5,6.5A6.508,6.508,0,0,0,17.415,11Zm2.652,8.091a.75.75,0,1,1-1.061,1.06l-1.414-1.414a.252.252,0,0,0-.354,0L15.824,20.15a.75.75,0,0,1-1.06-1.06l1.414-1.414a.252.252,0,0,0,0-.354l-1.414-1.414a.75.75,0,0,1,1.06-1.06l1.414,1.414a.252.252,0,0,0,.354,0l1.414-1.414a.75.75,0,0,1,1.061,1.06l-1.414,1.414a.25.25,0,0,0,0,.354Z']],
  TagsShare: ['tags-share', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.537,14.01a.492.492,0,0,0,.343-.143l5.347-5.456A3.978,3.978,0,0,0,20.212,6V2a2,2,0,0,0-2-2h0l-4.26.006a3.933,3.933,0,0,0-2.411,1L.712,11.834a2,2,0,0,0,0,2.828L5.548,19.5a1.972,1.972,0,0,0,1.406.582h.012a1.972,1.972,0,0,0,1.41-.6l.877-.895a.491.491,0,0,0,.136-.345A4.207,4.207,0,0,1,13.537,14.01ZM16.712,5.5a2,2,0,1,1-2-2A2,2,0,0,1,16.712,5.5Z', 'M23.874,13.749a2.746,2.746,0,1,0-5.437.539.252.252,0,0,1-.116.268l-2.666,1.6a.252.252,0,0,1-.288-.022,2.72,2.72,0,0,0-1.743-.634,2.75,2.75,0,1,0,2.055,4.559.249.249,0,0,1,.28-.067l2.272.909a.25.25,0,0,1,.157.246,2.758,2.758,0,1,0,.681-1.706.252.252,0,0,1-.281.067L16.524,18.6a.251.251,0,0,1-.157-.253,2.122,2.122,0,0,0-.056-.638.249.249,0,0,1,.116-.268l2.665-1.6a.25.25,0,0,1,.288.022,2.741,2.741,0,0,0,4.494-2.116Z']],
  TagsAlertAlternate: ['tags-alert-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.667 6.009 A1.497 1.497 0 1 0 18.661 6.009 A1.497 1.497 0 1 0 15.667 6.009 Z', 'M18.813,12.27a1.446,1.446,0,0,0-2.557,0l-5.048,9.617a1.43,1.43,0,0,0,.048,1.406,1.454,1.454,0,0,0,1.231.686h10.1a1.453,1.453,0,0,0,1.23-.686,1.427,1.427,0,0,0,.048-1.406Zm-1.279,2.474a.749.749,0,0,1,.749.749v2.995a.749.749,0,1,1-1.5,0V15.493A.749.749,0,0,1,17.534,14.744Zm0,5.491a1,1,0,1,1-1,1A1,1,0,0,1,17.534,20.235Z', 'M9.841,21.191l.136-.259a.059.059,0,0,0-.094-.069,1.025,1.025,0,0,1-1.412,0L2.31,14.7a1,1,0,0,1,0-1.412L13.291,2.309A.993.993,0,0,1,14,2.016h6.66a.5.5,0,0,1,.5.5v6.66a.993.993,0,0,1-.293.707l-.983.984a.25.25,0,0,0-.025.325,2.95,2.95,0,0,1,.242.383l.5.944a.25.25,0,0,0,.4.061l1.285-1.286a2.973,2.973,0,0,0,.877-2.118V2.016a2,2,0,0,0-2-2H14A2.973,2.973,0,0,0,11.88.9L.9,11.878a3,3,0,0,0,0,4.235L7.06,22.275a2.984,2.984,0,0,0,2.117.876l.11,0a.25.25,0,0,0,.239-.277A2.92,2.92,0,0,1,9.841,21.191Z']],
  TagsSearchAlternate: ['tags-search-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.670 5.999 A1.500 1.500 0 1 0 18.670 5.999 A1.500 1.500 0 1 0 15.670 5.999 Z', 'M10.578,16.528a5.523,5.523,0,0,0,8.5,4.66.25.25,0,0,1,.311.034l2.484,2.484a1,1,0,1,0,1.414-1.414L20.8,19.808a.251.251,0,0,1-.034-.312,5.527,5.527,0,1,0-10.189-2.968Zm9.058,0A3.529,3.529,0,1,1,16.107,13,3.533,3.533,0,0,1,19.636,16.528Z', 'M21.17,0H14a2.98,2.98,0,0,0-2.122.879l-11,11a3,3,0,0,0,0,4.242l6.172,6.172a3,3,0,0,0,4.242,0l.138-.137a.251.251,0,0,0-.013-.366,6.985,6.985,0,0,1-.991-1.057.251.251,0,0,0-.376-.026l-.172.172a1.025,1.025,0,0,1-1.414,0L2.291,14.706a1,1,0,0,1,0-1.414l11-11A1,1,0,0,1,14,2H20.67a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708l-.67.67a.249.249,0,0,0,.026.376,7.077,7.077,0,0,1,1.056.991.255.255,0,0,0,.18.086.252.252,0,0,0,.186-.073l.636-.636A2.978,2.978,0,0,0,23.17,9.17V2A2,2,0,0,0,21.17,0Z']],
  TagsDownloadAlternate: ['tags-download-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.670 5.999 A1.500 1.500 0 1 0 18.670 5.999 A1.500 1.500 0 1 0 15.670 5.999 Z', 'M9.9,21.191a.249.249,0,0,0-.32-.114,1.029,1.029,0,0,1-1.118-.2L2.291,14.706a1,1,0,0,1,0-1.414l11-11A1,1,0,0,1,14,2H20.67a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708l-.166.166a.251.251,0,0,0,.059.4A7.98,7.98,0,0,1,22,11.257a.25.25,0,0,0,.342-.027,2.927,2.927,0,0,0,.825-2.06V2a2,2,0,0,0-2-2H14a2.982,2.982,0,0,0-2.122.879l-11,11a3,3,0,0,0,0,4.242l6.172,6.172a3.005,3.005,0,0,0,3.57.5.251.251,0,0,0,.077-.373A8,8,0,0,1,9.9,21.191Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm-.391,9.813-2-2.5A.5.5,0,0,1,15.5,17.5h.75a.25.25,0,0,0,.25-.25V14.5a1,1,0,0,1,2,0v2.75a.25.25,0,0,0,.25.25h.75a.5.5,0,0,1,.39.813l-2,2.5a.5.5,0,0,1-.781,0Z']],
  TagsEditAlternate: ['tags-edit-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.672 5.999 A1.500 1.500 0 1 0 18.672 5.999 A1.500 1.500 0 1 0 15.672 5.999 Z', 'M12.782,20.044a.5.5,0,0,0-.835.216l-.886,3.1a.5.5,0,0,0,.481.638.487.487,0,0,0,.137-.019l3.1-.886A.5.5,0,0,0,15,22.259Z', 'M18.814,13.227a.5.5,0,0,0-.707,0L13.1,18.237a.5.5,0,0,0,0,.707l3,3a.5.5,0,0,0,.707,0l5.011-5.01a.5.5,0,0,0,0-.707Z', 'M9.619,22.949l.544-1.9a.17.17,0,0,0-.284-.167,1.025,1.025,0,0,1-1.414,0L2.293,14.706a1,1,0,0,1,0-1.414l11-11A.993.993,0,0,1,14,2h6.672a.5.5,0,0,1,.5.5V9.17q0,.037,0,.075a.25.25,0,0,0,.25.269h.012a4.171,4.171,0,0,1,1.386.234.248.248,0,0,0,.215-.023.251.251,0,0,0,.117-.181,3.091,3.091,0,0,0,.023-.374V2a2,2,0,0,0-2-2H14a2.978,2.978,0,0,0-2.121.879l-11,11a3,3,0,0,0,0,4.242l6.172,6.172a2.99,2.99,0,0,0,2.121.877c.072,0,.144,0,.216-.008a.248.248,0,0,0,.223-.184Z', 'M19.525,11.809a.5.5,0,0,0-.151.354.507.507,0,0,0,.147.357l3,3a.54.54,0,0,0,.377.123.583.583,0,0,0,.377-.169,2.626,2.626,0,0,0,0-3.707A2.658,2.658,0,0,0,19.525,11.809Z']],
  TagsLock: ['tags-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.924,9.613l1.176-1.2A3.979,3.979,0,0,0,20.086,6V2a2,2,0,0,0-2-2h0L13.828.005a3.95,3.95,0,0,0-2.416,1L.586,11.834a2,2,0,0,0,0,2.828L5.422,19.5a1.972,1.972,0,0,0,1.406.582H6.84a1.975,1.975,0,0,0,1.41-.6l6-6.118a.463.463,0,0,0,.116-.2,4.986,4.986,0,0,1,3.361-3.429A.468.468,0,0,0,17.924,9.613ZM16.586,5.5a2,2,0,1,1-2-2A2,2,0,0,1,16.586,5.5Z', 'M22.714,15.514a.25.25,0,0,1-.214-.247V14.249a3.5,3.5,0,0,0-7,0v1.018a.249.249,0,0,1-.214.247A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17A1.5,1.5,0,0,0,22.714,15.514ZM20,20.249a1,1,0,1,1-1-1A1,1,0,0,1,20,20.249Zm-2.5-6a1.5,1.5,0,0,1,3,0v1a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25Z']],
  TagsRefreshAlternate: ['tags-refresh-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.670 5.999 A1.500 1.500 0 1 0 18.670 5.999 A1.500 1.500 0 1 0 15.670 5.999 Z', 'M11.353,22.782l.97-.969a.248.248,0,0,1,.358.005,6.086,6.086,0,0,0,10.21-2.2A1,1,0,1,0,21,18.972a4.091,4.091,0,0,1-6.919,1.419.249.249,0,0,1,.009-.344l1.721-1.722a.5.5,0,0,0-.353-.853H11a.5.5,0,0,0-.5.5v4.457a.492.492,0,0,0,.068.224.44.44,0,0,0,.087.111.466.466,0,0,0,.153.126A.5.5,0,0,0,11.353,22.782Z', 'M21.62,12.656a.249.249,0,0,1-.357-.005,6.1,6.1,0,0,0-10.2,2.227,1,1,0,0,0,1.893.648,4.091,4.091,0,0,1,6.9-1.445.249.249,0,0,1-.007.346l-1.659,1.66a.5.5,0,0,0,.354.853H23a.5.5,0,0,0,.5-.5V11.983a.5.5,0,0,0-.309-.462.488.488,0,0,0-.455.061c-.029.019-.065.023-.09.048Z', 'M9,22.429V21.341a.251.251,0,0,0-.169-.237.952.952,0,0,1-.368-.226L2.291,14.706a1,1,0,0,1,0-1.414l11-11A1,1,0,0,1,14,2H20.67a.5.5,0,0,1,.5.5V9.17a1,1,0,0,1-.293.708l-.11.11a.251.251,0,0,0,.046.39q.207.126.406.266a.249.249,0,0,0,.32-.028l.228-.228a.238.238,0,0,1,.077-.052l.178-.077.024-.012a2.014,2.014,0,0,1,.982-.258.038.038,0,0,0,.037-.028,3.023,3.023,0,0,0,.105-.791V2a2,2,0,0,0-2-2H14a2.98,2.98,0,0,0-2.122.879l-11,11a3,3,0,0,0,0,4.242l6.172,6.172a2.983,2.983,0,0,0,1.72.85.25.25,0,0,0,.277-.3A1.842,1.842,0,0,1,9,22.429Z']],
  TagsCash: ['tags-cash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11ZM16,21.249a.75.75,0,1,1,0-1.5h2.033a.592.592,0,0,0,.221-1.141l-2.065-.826a2.084,2.084,0,0,1,.361-3.98.249.249,0,0,0,.2-.245v-.308a.75.75,0,0,1,1.5,0v.25a.25.25,0,0,0,.25.25H19a.75.75,0,0,1,0,1.5H16.967a.592.592,0,0,0-.221,1.141l2.065.826a2.084,2.084,0,0,1-.361,3.98.249.249,0,0,0-.2.245v.308a.75.75,0,0,1-1.5,0V21.5a.25.25,0,0,0-.25-.25Z', 'M5.422,19.5a1.972,1.972,0,0,0,1.406.582H6.84a1.975,1.975,0,0,0,1.41-.6l1.217-1.241a.493.493,0,0,0,.136-.367,7.976,7.976,0,0,1,8.2-8.363.486.486,0,0,0,.363-.143l.939-.958A3.984,3.984,0,0,0,20.086,6V2a2,2,0,0,0-2-2h0L13.826,0a3.758,3.758,0,0,0-2.413,1L.586,11.834a2,2,0,0,0,0,2.828Zm7.164-14a2,2,0,1,1,2,2A2,2,0,0,1,12.586,5.5Z']]
};
exports["default"] = _default;